import * as types from './actionTypes';  
import ordersMetaDataApi from '../api/ordersMetaDataApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doFetchOrdersMetadata(ext_id) {

  return {
    type: types.DO_FETCH_ORDERS_METADATA,
    ext_id
  };
}

export function doFetchOrdersMetadataRes(data) {  
  return {
    type: types.DO_FETCH_ORDERS_METADATA_RES, 
    data
  };
}
export function fetchOrdersMetaData(ext_id) {
  const TOKEN = getItem('auth_token');
  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      ordersMetaDataApi.doFetchOrdersMetadata(ext_id).then(data => {
        dispatch(doFetchOrdersMetadataRes(data));
        dispatch(doFetchOrdersMetadataRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}